document.addEventListener("DOMContentLoaded", function() {
    var mediaGallery = document.getElementById("MediaGallery-template--23039339430081__main");
    var priceElement = document.getElementById("price-template--23039339430081__main");
    
    if (!mediaGallery || !priceElement) return;
    
    var originalParent = mediaGallery.parentElement;
    var originalNextSibling = mediaGallery.nextElementSibling;
    
    function repositionElements() {
      if (window.innerWidth <= 767) {
        if (priceElement.parentNode) {
          priceElement.parentNode.insertBefore(mediaGallery, priceElement.nextElementSibling);
        }
      } else {
        if (originalParent) {
          if (originalNextSibling) {
            originalParent.insertBefore(mediaGallery, originalNextSibling);
          } else {
            originalParent.appendChild(mediaGallery);
          }
        }
      }
    }
    
    repositionElements();
    window.addEventListener("resize", repositionElements);
  });